import { z } from 'zod';
import { uiLocaleSchema, type UiLocale } from './localization-contracts';

export const personaSlugSchema = z.enum(['business', 'expat', 'senior', 'nomad', 'vacation']);
export type PersonaSlug = z.infer<typeof personaSlugSchema>;

export const scenarioTierSchema = z.enum(['free', 'pack', 'subscription']);
export type ScenarioTier = z.infer<typeof scenarioTierSchema>;

export const accentColorSchema = z.enum(['coral', 'navy', 'leaf', 'sand', 'ink']);
export type AccentColor = z.infer<typeof accentColorSchema>;

export const personaScenarioSchema = z.object({
  slug: z.string().min(1).max(80),
  tier: scenarioTierSchema,
  display_order: z.number().int().nonnegative(),
  category: z.string().min(1),
  is_launch: z.boolean(),
});
export type PersonaScenario = z.infer<typeof personaScenarioSchema>;

export const personaSchema = z.object({
  slug: personaSlugSchema,
  display_order: z.number().int().min(1).max(5),
  accent_color: accentColorSchema,
  scenarios: z.array(personaScenarioSchema),
});
export type Persona = z.infer<typeof personaSchema>;

export const personasResponseSchema = z.array(personaSchema);

export const launchScenarioSchema = z.object({
  slug: z.string().min(1),
  category: z.string().min(1),
  is_launch: z.boolean(),
});
export const launchScenariosResponseSchema = z.array(launchScenarioSchema);
export type LaunchScenario = z.infer<typeof launchScenarioSchema>;

export const publicTweaksSchema = z.object({
  palette: z.enum(['globe', 'passport', 'departures', 'coastal']),
  heroVariant: z.enum(['default', 'bolder', 'quiet', 'business']),
  heroLayout: z.enum(['split', 'video', 'static']),
  ctaCopy: z.enum(['default', 'travel', 'direct', 'outcome']),
  density: z.enum(['compact', 'regular', 'airy']),
  dark: z.boolean(),
  displayFont: z.enum(['serif', 'sans']),
  showComparison: z.boolean(),
  showFounder: z.boolean(),
  showMiniDemos: z.boolean(),
  showTrustStrip: z.boolean(),
  personaLayout: z.enum(['timeline', 'grid', 'accordion']),
  pricingLayout: z.enum(['cards', 'table', 'toggle']),
  showWaveforms: z.boolean(),
  routeIntensity: z.number().min(0).max(0.8),
});
export type PublicTweaks = z.infer<typeof publicTweaksSchema>;

export const adminTweaksUpdateSchema = publicTweaksSchema;
export type AdminTweaksUpdate = z.infer<typeof adminTweaksUpdateSchema>;

/** @deprecated Import uiLocaleSchema from localization-contracts in new code. */
export const localeCodeSchema = uiLocaleSchema;
/** @deprecated Import UiLocale from localization-contracts in new code. */
export type LocaleCode = UiLocale;
